<script setup>
import { useRoute } from '@js/utils/route';
import { toastError, toastUpdated } from '@js/utils/toast';
import { ref } from 'vue';

const { googleAdsProductManagement, tenant, callback } = defineProps({
    googleAdsProductManagement: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route(
                'front.projectManagement.sea.postUpdateCpcProductManagement',
                {
                    tenant: tenant.id,
                    googleAdsProductManagement: googleAdsProductManagement.id,
                },
            ),
        )
        .then(() => {
            toastUpdated();

            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            toastError('Une erreur est survenue.');
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
